/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PresignCaptureMediaRequest
 */
export interface PresignCaptureMediaRequest {
    /**
     * 
     */
    captureId: string;
    /**
     * 
     */
    filename: string;
    /**
     * 
     */
    contentType: string;
}

/**
 * Check if a given object implements the PresignCaptureMediaRequest interface.
 */
export function instanceOfPresignCaptureMediaRequest(value: object): value is PresignCaptureMediaRequest {
    if ((!('captureId' in (value as Record<string, any>)) && !('capture_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['captureId'] === undefined && (value as Record<string, any>)['capture_id'] === undefined)) return false;
    if (!('filename' in value) || value['filename'] === undefined) return false;
    if ((!('contentType' in (value as Record<string, any>)) && !('content_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['contentType'] === undefined && (value as Record<string, any>)['content_type'] === undefined)) return false;
    return true;
}

export function PresignCaptureMediaRequestFromJSON(json: any): PresignCaptureMediaRequest {
    return PresignCaptureMediaRequestFromJSONTyped(json, false);
}

export function PresignCaptureMediaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PresignCaptureMediaRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'captureId': json['capture_id'],
        'filename': json['filename'],
        'contentType': json['content_type'],
    };
}

export function PresignCaptureMediaRequestToJSON(json: any): PresignCaptureMediaRequest {
    return PresignCaptureMediaRequestToJSONTyped(json, false);
}

export function PresignCaptureMediaRequestToJSONTyped(value?: PresignCaptureMediaRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'capture_id': value['captureId'],
        'filename': value['filename'],
        'content_type': value['contentType'],
    };
}

